import type { ProductSearchFilterCategory } from '@jane/bloom/viewModels/productSearchFilters';

// sort alphabetically
export function getDefaultSortedCategories({
  categories,
}: {
  categories: ProductSearchFilterCategory[];
}) {
  return categories.sort((a, b) => {
    return a.label.localeCompare(b.label);
  });
}
